/*
  Front-End page for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col } from 'react-bootstrap'

function FrontEnd () {
  return (
    <>
      <Helmet>
        <title>Front-End Dev | FullStack.cash</title>
      </Helmet>

      <Container className='py-5'>
        <Row className='mb-5'>
          <Col md={6}>
            <h2>Front-End: Web & Phone Apps</h2>
            <p>
              Learn how to fork{' '}
              <a href='wallet.fullstack.cash' target='_blank' rel='noreferrer'>
                wallet.fullstack.cash
              </a>{' '}
              to build your own custom web or phone app that can interact with
              the Bitcoin Cash or eCash blockchains.
            </p>
            <p>
              The web wallet is based on{' '}
              <a href='https://create-react-app.dev/' target='_blank' rel='noreferrer'>
                React
              </a>.{' '}
              We provide boilerplates,
              plugins, and example apps. Your app can be compiled into native iOS and
              Android apps using{' '}
              <a href='https://capacitorjs.com/' target='_blank' rel='noreferrer'>
                Capacitor
              </a>
              .
            </p>
          </Col>
          <Col md={6}>
            <h4>
              These graduated boilerplates start simple and increasingly
              add features. They are all based
              on <a href='https://create-react-app.dev/' target='_blank' rel='noreferrer'>Create React App</a> and <a href='https://react-bootstrap.github.io/' target='_blank' rel='noreferrer'>React Bootstrap</a>.
            </h4>
            <ul>
              <li>
                <a href='https://github.com/Permissionless-Software-Foundation/react-bootstrap-web3-spa' target='_blank' rel='noreferrer'>
                  react-bootstrap-web3-spa
                </a> - Single Page App (SPA) integrating <a href='https://www.npmjs.com/package/minimal-slp-wallet' target='_blank' rel='noreferrer'>minimal-slp-wallet</a>.
              </li>
              <li>
                <a href='https://github.com/Permissionless-Software-Foundation/react-bootstrap-web3-android' target='_blank' rel='noreferrer'>
                  react-bootstrap-web3-android
                </a> - Same as above, but with <a href='https://capacitorjs.com/' target='_blank' rel='noreferrer'>CapacitorJS</a> integrated
                to convert the web app to a native Android APK.
              </li>
              <li>
                <a href='https://github.com/Permissionless-Software-Foundation/bch-wallet-web3-android' target='_blank' rel='noreferrer'>
                  bch-wallet-web3-android
                </a> - Based on the above two libraries. A full-features web wallet for Bitcoin Cash.
              </li>
            </ul>
          </Col>
        </Row>

        <Row>
          <Col>
            <h2 className='text-center mb-4'>React Boilerplates</h2>
            <p className='text-center mb-4'>
              Armed with an understanding of React and the boilerplates below,
              you can quickly build your own Bitcoin Cash web app. You can even
              compile it into an Android or iOS native application.
            </p>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default FrontEnd
